import {
  changePassword,
  createOrganizationMember,
  createReview,
  deleteOrganizationMember,
  editOrganizationMember,
  fetchAllOrganizationChatters,
  fetchAllOrganizationInfluencers,
  fetchAllOrganizationTeamLeads,
  fetchInfluencerById,
  fetchInfluencerInfo,
  fetchOrganizationMembersInfo,
  generateInfluencerPersonality,
  uploadInfluencerVoice,
  testInfluencerVoice,
  saveInfluencerVoice,
  editInfluencerPricing,
  uploadInfluencerQuestionnaire,
  refreshInfluencerFactsStatus,
  fetchReviewById,
  fetchReviews,
  getOrganizationMemberById,
} from './asyncThunks';

export const changePasswordBuilder = builder => {
  builder.addCase(changePassword.pending, state => {
    state.pending.changePassword = true;
  });
  builder.addCase(changePassword.fulfilled, state => {
    state.pending.changePassword = false;
  });
  builder.addCase(changePassword.rejected, state => {
    state.pending.changePassword = false;
  });
};

export const fetchInfluencesBuilder = builder => {
  builder.addCase(fetchInfluencerInfo.pending, state => {
    state.fetchInfluencersInfo.pending = true;
  });
  builder.addCase(fetchInfluencerInfo.fulfilled, (state, { payload }) => {
    const { data, total } = payload;
    state.fetchInfluencersInfo.pending = false;
    state.fetchInfluencersInfo.data = data;
    state.fetchInfluencersInfo.total = total;
  });
  builder.addCase(fetchInfluencerInfo.rejected, state => {
    state.fetchInfluencersInfo.pending = false;
  });
};

export const fetchInfluencerByIdBuilder = builder => {
  builder.addCase(fetchInfluencerById.pending, state => {
    state.pending.fetchInfluencerById = true;
  });
  builder.addCase(fetchInfluencerById.fulfilled, (state, { payload }) => {
    state.pending.fetchInfluencerById = false;
    state.selectedInfluencer = payload.influencer;
  });
  builder.addCase(fetchInfluencerById.rejected, state => {
    state.pending.fetchInfluencerById = false;
  });
};

export const generateInfluencerPersonalityBuilder = builder => {
  builder.addCase(generateInfluencerPersonality.pending, state => {
    state.pending.generateInfluencerPersonality = true;
  });
  builder.addCase(generateInfluencerPersonality.fulfilled, state => {
    state.pending.generateInfluencerPersonality = false;
    if (state.selectedInfluencer) {
      state.selectedInfluencer.hasPersonality = true;
    }
  });
  builder.addCase(generateInfluencerPersonality.rejected, state => {
    state.pending.generateInfluencerPersonality = false;
  });
};

export const uploadInfluencerVoiceBuilder = builder => {
  builder.addCase(uploadInfluencerVoice.pending, state => {
    state.pending.uploadInfluencerVoice = true;
  });
  builder.addCase(uploadInfluencerVoice.fulfilled, state => {
    state.pending.uploadInfluencerVoice = false;
  });
  builder.addCase(uploadInfluencerVoice.rejected, state => {
    state.pending.uploadInfluencerVoice = false;
  });
};

export const testInfluencerVoiceBuilder = builder => {
  builder.addCase(testInfluencerVoice.pending, state => {
    state.pending.testInfluencerVoice = true;
  });
  builder.addCase(testInfluencerVoice.fulfilled, state => {
    state.pending.testInfluencerVoice = false;
  });
  builder.addCase(testInfluencerVoice.rejected, state => {
    state.pending.testInfluencerVoice = false;
  });
};

export const saveInfluencerVoiceBuilder = builder => {
  builder.addCase(saveInfluencerVoice.pending, state => {
    state.pending.saveInfluencerVoice = true;
  });
  builder.addCase(saveInfluencerVoice.fulfilled, state => {
    state.pending.saveInfluencerVoice = false;
    if (state.selectedInfluencer) {
      state.selectedInfluencer.hasVoice = true;
    }
  });
  builder.addCase(saveInfluencerVoice.rejected, state => {
    state.pending.saveInfluencerVoice = false;
  });
};

export const editInfluencerPricingBuilder = builder => {
  builder.addCase(editInfluencerPricing.pending, state => {
    state.pending.editInfluencerPricing = true;
  });
  builder.addCase(editInfluencerPricing.fulfilled, (state, { payload }) => {
    state.pending.editInfluencerPricing = false;
    if (state.selectedInfluencer) {
      state.selectedInfluencer.pricing = payload.pricing;
    }
  });
  builder.addCase(editInfluencerPricing.rejected, state => {
    state.pending.editInfluencerPricing = false;
  });
};

export const uploadInfluencerQuestionnaireBuilder = builder => {
  builder.addCase(uploadInfluencerQuestionnaire.pending, state => {
    state.pending.uploadInfluencerQuestionnaire = true;
  });
  builder.addCase(uploadInfluencerQuestionnaire.fulfilled, state => {
    state.pending.uploadInfluencerQuestionnaire = false;
    if (state.selectedInfluencer) {
      state.selectedInfluencer.isFactsQuestionnaireProcessing = true;
    }
  });
  builder.addCase(uploadInfluencerQuestionnaire.rejected, state => {
    state.pending.uploadInfluencerQuestionnaire = false;
  });
};

export const refreshInfluencerFactsStatusBuilder = builder => {
  builder.addCase(refreshInfluencerFactsStatus.fulfilled, (state, { payload }) => {
    if (state.selectedInfluencer?.id === payload.influencer.id) {
      state.selectedInfluencer.hasFacts = payload.influencer.hasFacts;
      state.selectedInfluencer.isFactsQuestionnaireProcessing = payload.influencer.isFactsQuestionnaireProcessing;
    }
  });
};

export const fetchOrganizationMembersInfoBuilder = builder => {
  builder.addCase(fetchOrganizationMembersInfo.pending, state => {
    state.fetchOrganizationMembersInfo.pending = true;
  });
  builder.addCase(fetchOrganizationMembersInfo.fulfilled, (state, { payload }) => {
    const { data, total } = payload;
    state.fetchOrganizationMembersInfo.pending = false;
    state.fetchOrganizationMembersInfo.data = data;
    state.fetchOrganizationMembersInfo.total = total;
  });
  builder.addCase(fetchOrganizationMembersInfo.rejected, state => {
    state.fetchOrganizationMembersInfo.pending = false;
  });
};

export const fetchAllOrganizationInfluencersBuilder = builder => {
  builder.addCase(fetchAllOrganizationInfluencers.fulfilled, (state, { payload }) => {
    const { influencers } = payload;
    state.influencerOptions = influencers.map(influencer => ({
      label: influencer.name,
      value: influencer._id,
    }));
  });
};

export const createOrganizationMemberBuilder = builder => {
  builder.addCase(createOrganizationMember.pending, state => {
    state.pending.createOrganizationMember = true;
  });
  builder.addCase(createOrganizationMember.fulfilled, state => {
    state.pending.createOrganizationMember = false;
  });
  builder.addCase(createOrganizationMember.rejected, state => {
    state.pending.createOrganizationMember = false;
  });
};

export const fetchAllOrganizationChattersBuilder = builder => {
  builder.addCase(fetchAllOrganizationChatters.fulfilled, (state, { payload }) => {
    const { chatters } = payload;
    state.chattersOptions = chatters.map(chatter => ({
      label: chatter.name,
      value: chatter._id,
    }));
  });
};

export const fetchAllOrganizationTeamLeadsBuilder = builder => {
  builder.addCase(fetchAllOrganizationTeamLeads.fulfilled, (state, { payload }) => {
    const { teamLeads } = payload;
    state.teamLeadsOptions = teamLeads.map(teamLead => ({
      label: teamLead.name,
      value: teamLead._id,
    }));
  });
};

export const deleteOrganizationMemberBuilder = builder => {
  builder.addCase(deleteOrganizationMember.pending, state => {
    state.pending.deleteOrganizationMember = true;
  });
  builder.addCase(deleteOrganizationMember.fulfilled, state => {
    state.pending.deleteOrganizationMember = false;
  });
  builder.addCase(deleteOrganizationMember.rejected, state => {
    state.pending.deleteOrganizationMember = false;
  });
};

export const getOrganizationMemberByIdBuilder = builder => {
  builder.addCase(getOrganizationMemberById.pending, state => {
    state.pending.getOrganizationMemberById = true;
  });
  builder.addCase(getOrganizationMemberById.fulfilled, state => {
    state.pending.getOrganizationMemberById = false;
  });
  builder.addCase(getOrganizationMemberById.rejected, state => {
    state.pending.getOrganizationMemberById = false;
  });
};

export const editOrganizationMemberBuilder = builder => {
  builder.addCase(editOrganizationMember.pending, state => {
    state.pending.editOrganizationMember = true;
  });
  builder.addCase(editOrganizationMember.fulfilled, state => {
    state.pending.editOrganizationMember = false;
  });
  builder.addCase(editOrganizationMember.rejected, state => {
    state.pending.editOrganizationMember = false;
  });
};

export const createReviewBuilder = builder => {
  builder.addCase(createReview.pending, state => {
    state.pending.createReview = true;
  });
  builder.addCase(createReview.fulfilled, state => {
    state.pending.createReview = false;
  });
  builder.addCase(createReview.rejected, state => {
    state.pending.createReview = false;
  });
};

export const fetchReviewsBuilder = builder => {
  builder.addCase(fetchReviews.pending, state => {
    state.fetchReviews.pending = true;
  });
  builder.addCase(fetchReviews.fulfilled, (state, { payload }) => {
    const { reviews } = payload;
    state.fetchReviews.pending = false;
    state.fetchReviews.data = reviews;
  });
  builder.addCase(fetchReviews.rejected, state => {
    state.fetchReviews.pending = false;
  });
};

export const fetchReviewByIdBuilder = builder => {
  builder.addCase(fetchReviewById.pending, state => {
    state.pending.fetchReviewById = true;
  });
  builder.addCase(fetchReviewById.fulfilled, (state, { payload }) => {
    const { review, isReviewer } = payload;
    state.pending.fetchReviewById = false;
    state.selectedReview = review;
    if (!isReviewer) {
      state.fetchReviews.data = state.fetchReviews.data.map(r => {
        if (r.id === review.id) {
          return { ...r, seen: true };
        } else {
          return r;
        }
      });
    }
  });
  builder.addCase(fetchReviewById.rejected, state => {
    state.pending.fetchReviewById = false;
  });
};
